module.exports = {
      id: "account-favorites-usage",
      viewBox: "0 0 21.6 17.6",
      url: __webpack_public_path__ + "img/icons.a7e6c507.svg#account-favorites-usage",
      toString: function () {
        return this.url;
      }
    }